// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 454) return "static/chunks/lucide-c69eda4537353f7f.js";
	if (chunkId === 592) return "static/chunks/common-b02b71758df9c553.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 775 ? "gsap" : chunkId) + "." + {"33":"6984470256cbd1ac","259":"236328eb75fee1e9","429":"da8f35a01806663a","704":"45fa358b07ba2005","775":"327d3b43888773c7","798":"80d2dc81e7a0a4db","894":"caae86c2d58dd301","913":"21ebd09c2d15c02e"}[chunkId] + ".js";
};